<template>
  <div class="hello" @click="handleClick">
    <!-- 内容区：超出一屏时在内部滚动，保证页脚始终贴在视口底部 -->
    <div class="content">
      <img class='zhu' src="@/assets/zhu.jpg" alt="猪"/>
      <h1>{{ msg }}</h1>
      <h2>我是</h2>
      <img class="haixing" src="@/assets/haixing.jpg" alt="海星">
    </div>
    <!-- 备案页脚：展示 ICP 备案编号并链接至工信部备案查询页；@click.stop 阻止冒泡，避免触发 .hello 上的 handleClick 跳转 -->
    <div class="footer">
      <a
        class="beian-link"
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
        @click.stop
      >粤ICP备2020118425号-1</a>
    </div>
  </div>
</template>

<script>
import { homeClick } from '@/api/home';
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: '欢迎来到我的网站',
      // 初始窗口宽度和高度
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight
    }
  },
  mounted() {
    /*
    // 添加点击事件监听器
    window.addEventListener('click', this.handleClick);
    // 添加触摸事件监听器以覆盖iOS Safari的行为
    window.addEventListener('touchstart', this.handleClick);
    */
    // 添加resize事件监听器来更新窗口尺寸
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    /*
    // 移除监听器以防内存泄露
    window.removeEventListener('click', this.handleClick);
    // 移除触摸事件监听器
    window.removeEventListener('touchstart', this.handleClick);
    */
    // 移除监听器
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleClick(event) {
      // event.clientX 和 event.clientY 会给你点击位置的坐标
      let x, y;
      // 检查事件类型
      if (event.touches && event.touches.length) {
        // 触摸事件
        x = event.touches[0].clientX;
        y = event.touches[0].clientY;
      } else {
        // 鼠标事件
        x = event.clientX;
        y = event.clientY;
      }
      const w = this.windowWidth;
      const h = this.windowHeight;
      // console.log(`Clicked at x: ${x}, y: ${y}, w: ${w}, h: ${h}`);
      // alert(`Clicked at x: ${x}, y: ${y}, w: ${w}, h: ${h}`);
      homeClick(x, y, w, h)
      .then(res => {
        if(res && res.data && res.data.url){
          window.location = res.data.url;
        }
      });
    },
    handleResize() {
      // 更新窗口尺寸
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.hello{
  padding-top: 60px;
  box-sizing: border-box;
  width: 100vw;
  /* 固定为一屏高度，保证页脚始终贴在视口底部 */
  height: 100vh;
  overflow: hidden;
  /* 纵向 flex 布局：内容区在上，页脚贴底 */
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  /* 内容区：超出一屏时在内部滚动，不影响页脚位置 */
  .content{
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
    overflow-y: auto;
  }
  .haixing{
    width: 150px;
  }
  .zhu{
    width: 200px;
  }
  /* 备案页脚：位于页面底部，居中灰色小字，并适配移动端底部安全区 */
  .footer{
    flex: 0 0 auto;
    margin-top: auto;
    padding: 16px 12px;
    padding-bottom: calc(16px + env(safe-area-inset-bottom));
    font-size: 12px;
    color: #999;
    .beian-link{
      color: #999;
      text-decoration: none;
    }
  }
}
/* PC/桌面端：postcss-px-to-viewport 会把 px 转成 vw，导致宽屏字号过大；
   这里用 #app 提高优先级覆盖插件生成的 landscape vw 值，把字号/图片固定为常规桌面尺寸；
   媒体查询内的 px 不会被插件转换，因此保持为固定 px。移动端（<768px）不受影响。 */
@media screen and (min-width: 768px) {
  #app .hello{
    padding-top: 40px;
    font-size: 14px;
  }
  #app .hello h1{
    font-size: 24px;
  }
  #app .hello h2{
    font-size: 18px;
  }
  #app .hello .zhu{
    width: 260px;
  }
  #app .hello .haixing{
    width: 200px;
  }
  #app .hello .footer{
    padding: 12px;
    padding-bottom: calc(12px + env(safe-area-inset-bottom));
    font-size: 12px;
  }
}
</style>
